import React from 'react';
import CustomButton from './CustomButton';
import Hidden from '@material-ui/core/Hidden';
// import CustomDialog from '../customDialog';
import PasscodeFlowDialog from './PasscodeFlowDialog';

function EventActions({
  actionsCont,
  endEventBtn,
  toggleStatus,
  dummy,
  editEventBtn,
  onClickEdit,
  onClickReserve,
  onClickAddP,
  onClickInvitees,
  eventStatus,
  pageFrom,
  isUserId,
  isLogin,
  allowUsersToReserveBox,
  onClickSignIn,
  onClickWatch,
  isBoxOwner,
  isSeatAvailable,
  eventId,
  eventUniqueNo,
  isEventPublic,
  isGuestAllowed,
}) {
  const renderEventToggleBtn = (eventStatus) => {
    switch (eventStatus) {
      case 'active':
        return (
          <CustomButton
            btnText="End Event"
            btnStyle={endEventBtn}
            clickHandle={() => toggleStatus('expired')}
          />
        );

      default:
        return (
          <CustomButton
            btnText="Start Event"
            btnStyle={editEventBtn}
            clickHandle={() => toggleStatus('active')}
          />
        );
    }
  };

  const renderWatchEventBtn = (eventStatus) => {
    switch (eventStatus) {
      case 'active':
        return (
          <CustomButton
            btnText="Watch Event"
            btnStyle={editEventBtn}
            clickHandle={onClickWatch}
          />
        );

      default:
        return (
          <CustomButton
            btnText="Event Not Started"
            btnStyle={editEventBtn}
            clickHandle={onClickWatch}
          />
        );
    }
  };

  const renderAddPBtn = (isBoxOwner) => {
    switch (isBoxOwner) {
      case true:
        return (
          <CustomButton
            btnText="Add Participants"
            btnStyle={editEventBtn}
            clickHandle={onClickAddP}
          />
        );

      default:
        return null;
    }
  };

  const checkBoxAndSeat = (allowBox, isAlreadySeat, isEventPublic) => {
    // console.log(
    //   !(isEventPublic && !isAlreadySeat),
    //   isEventPublic,
    //   isAlreadySeat
    // );
    return (
      <>
        {allowBox === 'Y' ? (
          <CustomButton
            btnText="Reserve Box"
            btnStyle={editEventBtn}
            clickHandle={onClickReserve}
          />
        ) : null}
        {!(isEventPublic && !isAlreadySeat) ? null : (
          <CustomButton
            btnText="Select Seat"
            btnStyle={editEventBtn}
            clickHandle={onClickAddP}
          />
        )}
      </>
    );
  };
  // !(true && !false)? 'null':'select seat'
  //pub noS -ok
  //pub havS -ok
  //nP noS
  //np havs

  const passcodeFlow = () => {
    return (
      <>
        <Hidden xsDown>
          <div className={dummy}></div>
        </Hidden>

        {isLogin
          ? checkBoxAndSeat(
              allowUsersToReserveBox,
              isSeatAvailable,
              isEventPublic
            )
          : showLoginOnly()}

        {isGuestAllowed ? (
          <PasscodeFlowDialog eventId={eventId} eventUniqueNo={eventUniqueNo} />
        ) : null}
      </>
    );
  };

  const showLoginOnly = () => {
    return (
      <>
        {/* <Hidden xsDown>
          <div className={dummy}></div>
        </Hidden> */}
        <CustomButton
          btnText="Sign In"
          btnStyle={editEventBtn}
          clickHandle={onClickSignIn}
        />
      </>
    );
  };

  const showGuestActions = () => {
    return (
      <>
        <Hidden xsDown>
          <div className={dummy}></div>
        </Hidden>
        {allowUsersToReserveBox === 'Y' ? (
          <CustomButton
            btnText="Reserve Box"
            btnStyle={editEventBtn}
            clickHandle={onClickReserve}
          />
        ) : null}

        <CustomButton
          btnText="Select Seat"
          btnStyle={editEventBtn}
          clickHandle={onClickAddP}
        />
      </>
    );
  };

  const showHostActions = () => {
    return (
      <>
        {renderEventToggleBtn(eventStatus)}
        <Hidden xsDown>
          <div className={dummy}></div>
        </Hidden>
        <CustomButton
          btnText="Edit Event"
          btnStyle={editEventBtn}
          clickHandle={onClickEdit}
        />
        <CustomButton
          btnText="Reserve Box"
          btnStyle={editEventBtn}
          clickHandle={onClickReserve}
        />
        <CustomButton
          btnText="Add Participants"
          btnStyle={editEventBtn}
          clickHandle={onClickAddP}
        />
        <CustomButton
          btnText="View Invitees"
          btnStyle={editEventBtn}
          clickHandle={onClickInvitees}
        />
      </>
    );
  };

  const showInviteActions = () => {
    return (
      <>
        <Hidden xsDown>
          <div className={dummy}></div>
        </Hidden>
        {isSeatAvailable ? renderWatchEventBtn(eventStatus) : passcodeFlow()}
        {renderAddPBtn(isBoxOwner)}
      </>
    );
  };

  const checkGuestStatus = () => {
    // if (isLoggedIn) {
    //   return showGuestActions();
    // } else {
    //   return showLoginOnly();
    //   //   // return null;
    // }
    return passcodeFlow();
  };

  const checkInviteStatus = () => {
    if (isUserId && isLogin) {
      return showInviteActions();
    } else {
      // return showLoginOnly();
      return passcodeFlow();
    }
    // return passcodeFlow();
  };

  const renderFunc = (pageFrom) => {
    switch (pageFrom) {
      case 'host_handle':
        return showHostActions();

      case 'share_handle':
        return checkGuestStatus();

      case 'invite_handle':
        return checkInviteStatus();

      default:
        return <div>Unauthorized access!</div>;
    }
  };

  return <div className={actionsCont}>{renderFunc(pageFrom)}</div>;
}

export default EventActions;
